/**
 * App OAuth helpers (Google). Redirect URI must match GOOGLE_REDIRECT_URIS.
 *
 * Locally Google only allows the special `http://localhost` redirect exception
 * (not `*.localhost` subdomains). Always use :5174 account-web for the callback
 * so the code exchange and AccountApp mount stay consistent.
 */

const OAUTH_RETURN_KEY = "pro-web-oauth-return";

export function getGoogleRedirectUri(): string {
  if (typeof window === "undefined") return "";
  const { hostname, protocol } = window.location;
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".localhost")
  ) {
    return `${protocol}//localhost:5174/auth/google/callback`;
  }
  return `${window.location.origin}/auth/google/callback`;
}

export function saveOAuthReturnPath(path: string) {
  try {
    sessionStorage.setItem(OAUTH_RETURN_KEY, path);
  } catch {
    // ignore storage failures
  }
}

export function consumeOAuthReturnPath(): string {
  try {
    const path = sessionStorage.getItem(OAUTH_RETURN_KEY);
    sessionStorage.removeItem(OAUTH_RETURN_KEY);
    return path && path.startsWith("/") ? path : "/";
  } catch {
    return "/";
  }
}
